// Zod-free leaf module: plain enums only (RET1-2734). Keep this file free of
// imports so lean bundles can use these values without loading zod schemas.

/** Credit type */
export enum StoreCreditType {
  /** Discount code */
  DISCOUNT_CODE = "discount_code",
  /** Gift card */
  GIFT_CARD = "gift_card",
}

/** How a return option offers a merchant-provided (manual) shipping label. */
export enum ManualLabelMode {
  /** Manual label is not offered; the shopper gets a Redo label. */
  OFF = "off",
  /**
   * The merchant provides the label outside Redo; Redo labels are not offered.
   */
  MERCHANT_FORCE = "merchant_force",
  /** The shopper buys their own postage; Redo labels are not offered. */
  SHOPPER_FORCE = "shopper_force",
  /** The shopper picks between a Redo label and the manual label. */
  SHOPPER_CHOICE = "shopper_choice",
}
